import React from 'react';
import { AddSharingDialog } from './index'
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { Scrollbars } from 'react-custom-scrollbars';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Divider from '@material-ui/core/Divider';
import red from '@material-ui/core/colors/red';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class AddParentDialog extends React.Component {
  state = {
    loading: false,
    initializing: false,
    initialized: false,
    data: [],
    children: [],
    selected_parent: null,
    add_sharing_dialog_open: false,
    snackbar_open: false
  }

  initialize = () => {
    this.setState({ initializing: true });
    let currentComponent = this;
    // Kinder laden
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getchildren", parent_id: this.props.parentId })
      .end(function (err, res) {
        var result = res.text.trim();
        var children = JSON.parse(result);

        // Eltern laden
        request.post(Constants.BACKEND_URL)
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('accept', 'json')
          .send({ command: "getchildrules", parent_id: currentComponent.props.parentId })
          .end((err, res) => {
            var result = res.text.trim();
            if (result !== "") {
              var obj = JSON.parse(result);
              currentComponent.setState({ children: children, data: obj, initializing: false, initialized: true });
            } else {
              currentComponent.setState({ snackbar_open: true, initializing: false, initialized: true });
            }
          });
      });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  onSelectParent = parent => {
    this.setState({ selected_parent: parent })
  }

  onLink = child_id => event => {
    var new_selected_parent = null;
    var new_data = JSON.parse(JSON.stringify(this.state.data));
    if (event.target.checked) {
      // Zuordnung hinzugefügt
      for (var i = 0; i < new_data.length; i++) {
        if (new_data[i].id === this.state.selected_parent.id) {
          new_data[i].links.push({ id: String(child_id), write_access: "0" });
          new_selected_parent = new_data[i];
          break;
        }
      }
    } else {
      // Zuordnung entfernt
      for (var i = 0; i < new_data.length; i++) {
        if (new_data[i].id === this.state.selected_parent.id) {
          for (var j = 0; j < new_data[i].links.length; j++) {
            if (new_data[i].links[j].id === child_id) {
              new_data[i].links.splice(j, 1);
              new_selected_parent = new_data[i];
              break;
            }
          }
          break;
        }
      }
    }
    this.setState({ selected_parent: new_selected_parent, data: new_data })
  }

  onGrantWriteAccess = child_id => event => {
    var new_selected_parent = null;
    var new_data = JSON.parse(JSON.stringify(this.state.data));
    for (var i = 0; i < new_data.length; i++) {
      if (new_data[i].id === this.state.selected_parent.id) {
        for (var j = 0; j < new_data[i].links.length; j++) {
          if (new_data[i].links[j].id === child_id) {
            new_data[i].links[j].write_access = event.target.checked ? "1" : "0";
            break;
          }
        }
        new_selected_parent = new_data[i];
        break;
      }
    }

    this.setState({ selected_parent: new_selected_parent, data: new_data })
  }

  onOpenAddSharingDialog = () => {
    this.setState({ add_sharing_dialog_open: true });
  }

  onAddPerson = person => {
    this.setState({ add_sharing_dialog_open: false });
    if (person !== null) {
      var new_data = JSON.parse(JSON.stringify(this.state.data));
      // Prüfen, ob die Person bereits existiert
      for (var i = 0; i < new_data.length; i++) {
        if (new_data[i].id === person.id || person.id === this.props.parentId) return;
      }
      person.links = [];
      new_data.push(person);
      this.setState({ data: new_data, selected_parent: person });
    }
  }

  applyChanges = () => {
    this.setState({ loading: true });
    // Eltern laden
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('accept', 'json')
      .send({ command: "savechildrules", parent_id: currentComponent.props.parentId, data: JSON.stringify(this.state.data) })
      .end((err, res) => {
        var result = res.text.trim();
        if (result === "1") {
          this.onClose();
        } else {
          currentComponent.setState({ snackbar_open: true, loading: false });
        }
      });
  }

  onClose = () => {
    this.setState({ data: [], selected_parent: null, initialized: false, loading: false });
    this.props.onClose();
  }

  onEnterPressed = (ev) => {
    if (ev.key === 'Enter') {
      this.applyChanges();
      ev.preventDefault();
    }
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false });
  }

  getChildFromId(child_id) {
    for (var i = 0; i < this.state.selected_parent.links.length; i++) {
      if (this.state.selected_parent.links[i].id === child_id) return this.state.selected_parent.links[i];
    }
    return null;
  }

  getChildFromIdFromChildList(child_id) {
    for (var i = 0; i < this.state.children.length; i++) {
      if (this.state.children[i].id === child_id) return this.state.children[i];
    }
    return null;
  }

  render() {
    const { classes } = this.props;

    if (this.props.open && !this.state.initialized && this.state.data.length === 0 && !this.state.initializing) this.initialize();

    return (
      <Dialog open={this.props.open} maxWidth="xl">
        <DialogTitle>{"Kinder für weitere Nutzerkonten freigeben"}</DialogTitle>
        <DialogContent style={{ padding: 0, height: 500, width: 900 }}>
          <Divider />
          {/* Freigaben */}
          <div style={{ position: "absolute", top: 55, width: 325, height: 500 }}>
            <div style={{ position: "absolute", top: 0, bottom: 90, left: 0, right: 0 }}>
              <Scrollbars>
                <List>
                  {this.state.data.map(parent => (
                    <ListItem button onClick={() => this.onSelectParent(parent)} selected={this.state.selected_parent !== null && this.state.selected_parent.id === parent.id} divider>
                      <Avatar><AccountCircle /></Avatar>
                      <ListItemText style={{ marginLeft: 15 }} primary={parent.first_name + " " + parent.last_name} secondary={parent.links.length > 0 ? (parent.links.length > 1 ? parent.links.length + " Kinder zugeordnet" : "1 Kind zugeordnet") : "Keine Zuordnungen"} />
                    </ListItem>
                  ))}
                </List>
              </Scrollbars>
            </div>
            {/* Leiste */}
            <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 65 }}>
              <Divider />
              <Fab variant="extended" style={{ marginTop: 7.5, marginBottom: 7.5, marginLeft: 40 }} onClick={this.onOpenAddSharingDialog}><AddIcon style={{ marginRight: 10 }} disabled={this.state.loading || this.state.initializing} />Freigabe hinzufügen</Fab>
              <Divider />
            </div>
          </div>
          {/* Divider */}
          <div style={{ position: "absolute", left: 325, top: 65, height: 490, width: 1, background: "lightgrey" }} />
          {/* Kinderliste */}
          <div style={{ position: "absolute", top: 55, left: 326, width: 574, height: 500 }}>
            {this.state.selected_parent != null && <Scrollbars>
              <List>
                {this.state.children.map(child => (
                  <ListItem button divider disabled={this.getChildFromIdFromChildList(child.id) !== null && this.getChildFromIdFromChildList(child.id).write_access === "0"}>
                    <ListItemText style={{ marginLeft: 15 }} primary={child.first_name + " " + child.last_name} />
                    <FormControlLabel control={<Checkbox checked={this.getChildFromId(child.id) !== null} onChange={this.onLink(child.id)} />} label="Freigegeben" />
                    <FormControlLabel control={<Checkbox checked={this.getChildFromId(child.id) !== null && this.getChildFromId(child.id).write_access === "1"} onChange={this.onGrantWriteAccess(child.id)} />} label="Schreibzugriff" disabled={this.getChildFromId(child.id) === null} />
                  </ListItem>
                ))}
              </List>
            </Scrollbars>}
            {this.state.selected_parent == null && <Typography align="center" style={{ position: 'absolute', width: 400, left: 287, top: '50%', transform: 'translate(-50%, -50%)' }}>Wählen Sie eine Person, um Zuordnungen zu bearbeiten oder neue anzulegen.</Typography>}
            <Divider style={{ position: "absolute", width: 574, bottom: 0 }} />
          </div>
          {/* initializing */}
          {this.state.initializing && <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}><CircularProgress color="secondary" /></div>}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onClose} variant="contained" disabled={this.state.loading || this.state.initializing}>Abbrechen</Button>
          <Button onClick={this.applyChanges} variant="contained" disabled={this.state.loading || this.state.initializing} color="primary" autoFocus>
            Änderungen Übernehmen
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* AddSharingDialog */}
        {this.props.open && <AddSharingDialog open={this.state.add_sharing_dialog_open} onAddPerson={this.onAddPerson} />}
        {/* Error-Snackbar */}
        <Snackbar className={classes.error} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />
                Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut!
              </span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

AddParentDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChildAdded: PropTypes.func.isRequired,
  parentId: PropTypes.string.isRequired
};

export default withMobileDialog()(withStyles(styles, { withTheme: true })(AddParentDialog));
